(function() {
  if (window.__productDescriptionPopupsBound) return;
  window.__productDescriptionPopupsBound = true;
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-description-popup-trigger]');
    if (!trigger) return;
    event.preventDefault();
    var targetId = trigger.getAttribute('data-description-popup-target');
    if (!targetId) return;
    var popupContent = document.getElementById(targetId);
    if (!popupContent) return;
    var html = popupContent.innerHTML;
    if (!html || !window.$s || typeof window.$s.openModal !== 'function') return;
    var schemeClass = popupContent.getAttribute('data-description-popup-scheme') || '';
    var wrapperClass = 'product-description-popup-modal scheme';
    if (schemeClass) wrapperClass += ' ' + schemeClass;
    window.$s.openModal('<div class="' + wrapperClass + '">' + html + '</div>', 'product-description-popup', {
      cssClass: ['product-description-popup'],
      onOpen: function() {
        if (window.$s && typeof window.$s.trapFocus === 'function') {
          window.$s.trapFocus(this.modal);
        }
        var modalRoot = this.modalBoxContent || this.modal;
        var carousel = modalRoot ? modalRoot.querySelector('component-carousel') : null;
        setTimeout(function() {
          if (!carousel) return;
          carousel.sliderElement = carousel.querySelector('.keen-slider');
          carousel.slides = carousel.querySelectorAll('.keen-slider-slide');
          if (carousel.sliderObj && typeof carousel.sliderObj.resize === 'function') {
            carousel.sliderObj.resize();
            return;
          }
          if (typeof carousel.initSlider === 'function') {
            carousel.initialized = false;
            carousel.initSlider();
          }
        }, 50);
        return true;
      }
    });
  });
})();
